import { IPartnerStatusResponse } from 'legacy/lut/classes/models/partnerStatus'

import { ProfilingRequestSource, ProfilingStatus } from 'clickNgo/configs/profiling/common'
import { TResponse } from 'core/classes/ws/WebSocketClient'
import { PARTNER_STATUS_ENDPOINT } from 'onboarding/api/partnerStatusApi'
import { callJSend } from 'shared/lib/http/callJSend'

class PartnerApi {
  public checkPartnerStatus = async (
    partnerId: string,
    locationId: string
  ): Promise<TResponse<IPartnerStatusResponse>> =>
    callJSend<IPartnerStatusResponse>({
      method: 'get',
      url: PARTNER_STATUS_ENDPOINT,
      payload: {
        ...(locationId ? { locationId } : {}),
        ...(partnerId ? { partnerId } : {}),
      },
    })

  public changePartnerStatus = async (
    locationId: string,
    status: ProfilingStatus,
    source: ProfilingRequestSource,
    requestId?: number
  ): Promise<TResponse<IPartnerStatusResponse>> =>
    callJSend<IPartnerStatusResponse>({
      method: 'post',
      url: PARTNER_STATUS_ENDPOINT,
      payload: { locationId, status, source, requestId },
    })
}

export default new PartnerApi()
